const TOGGLE_MENU = 'TOGGLE_MENU';

export {
  TOGGLE_MENU
};



// WEBPACK FOOTER //
// ./src/reducks/page/types.js